import { render } from "./DialogPage.vue?vue&type=template&id=eb7c0724&scoped=true"
import script from "./DialogPage.vue?vue&type=script&lang=js"
export * from "./DialogPage.vue?vue&type=script&lang=js"

import "./DialogPage.vue?vue&type=style&index=0&id=eb7c0724&scoped=true&lang=css"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb7c0724"]])

export default __exports__